<h2 mat-dialog-title>Contact Support</h2>

<form [formGroup]="form" (ngSubmit)="submit()">

  <mat-dialog-content>

    <mat-form-field appearance="outline" class="full-width">
      <mat-label>Type</mat-label>
      <mat-select formControlName="type">
        <mat-option value="bug">Bug</mat-option>
        <mat-option value="feature">Feature</mat-option>
        <mat-option value="question">Question</mat-option>
      </mat-select>
    </mat-form-field>

    <mat-form-field appearance="outline" class="full-width">
      <mat-label>Subject</mat-label>
      <input matInput formControlName="subject">
    </mat-form-field>

    <mat-form-field appearance="outline" class="full-width">
      <mat-label>Message</mat-label>
      <textarea matInput rows="4" formControlName="message"></textarea>
    </mat-form-field>

  </mat-dialog-content>

  <mat-dialog-actions align="end">
    <button mat-button type="button" (click)="close()">Cancel</button>
    <button matButton="filled" type="submit">Send</button>
  </mat-dialog-actions>

</form>